let _cachedApiUrl: string | undefined;

export function getImageUrl(path: string, apiUrl?: string): string {
  if (!path) return '';
  // Already a full URL — return as-is
  if (path.startsWith('http://') || path.startsWith('https://')) return path;

  // Use provided apiUrl, cached value, or try useRuntimeConfig()
  const base = apiUrl || _cachedApiUrl || (() => {
    try {
      const config = useRuntimeConfig();
      _cachedApiUrl = config.public.apiUrl;
      return _cachedApiUrl;
    } catch {
      return '';
    }
  })();

  return `${base}/${path}`;
}
